import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Companypaymentdetail = () => {
  const [companypaymentdetail, setCompanypaymentdetail] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`companypaymentdetail?page=${page}`);
      setCompanypaymentdetail(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`companypaymentdetail/${id}`);
      setCompanypaymentdetail(
        companypaymentdetail.filter(
          (companypaymentdetail) => companypaymentdetail.id !== id,
        ),
      );
    }
  };
  return (
    <Wrapper pageTitle={"Company Payment Detail"}>
      <InnerNav
        createLink={"/companypaymentdetailCreate"}
        listLink={"/companypaymentdetail"}
      />
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Bank </th>
                <th className="px-4 py-3">Bank Branch </th>
                <th className="px-4 py-3">Account Number </th>
                <th className="px-4 py-3">Paybill </th>
                <th className="px-4 py-3">Till Number </th>
                <th className="px-4 py-3">Mpesa Account Number </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {companypaymentdetail?.map((companypaymentdetail) => {
                return (
                  <tr
                    key={companypaymentdetail.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{companypaymentdetail.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {companypaymentdetail.bank}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {companypaymentdetail.bank_branch}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {companypaymentdetail.account_number}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {companypaymentdetail.pay_bill}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {companypaymentdetail.tillnumber}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {companypaymentdetail.mpesa_account_number}
                    </td>
                    <td className="flex px-4 py-3 text-sm">
                      <Link
                        className="btn btn-sm btn-outline-secondary px-5"
                        to={`/companypaymentdetail/${companypaymentdetail.id}/edit`}
                      >
                        <AiFillEdit />{" "}
                      </Link>
                      <span
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => del(companypaymentdetail.id)}
                      >
                        {" "}
                        <AiFillDelete className="text-rose-500 text-lg" />
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Companypaymentdetail;
